import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { DataGrid } from '@mui/x-data-grid';
import { CSVLink, CSVDownload } from "react-csv";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { columnsDisponibility, rowsDisponibility } from './helper_row_column';
import { WrapperGrid } from './styles';

const TableDisponibility = () => {
  const gridRef = React.useRef(null);

  const exportToPDF = () => {
    if (gridRef.current) {
      const gridContainer = gridRef.current;
      html2canvas(gridContainer).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        // eslint-disable-next-line new-cap
        const pdf = new jsPDF('p', 'mm', 'a4');
        pdf.addImage(imgData, 'PNG', 10, 10, 180, 0);
        pdf.save('table.pdf');
      });
    }
  };

  return (
    <WrapperGrid>
      <strong>Tabla de Disponibilidad</strong>
      <Box  
        sx={{
          height: 450,
          width: '100%',
          boxShadow: 2,
          borderColor: 'primary.light',
          '& .super-app-theme--header': {
            backgroundColor: '#5E75F2',
            color: 'white',
          },

        }}
        ref={gridRef}
      >
        <DataGrid
          rows={rowsDisponibility}
          columns={columnsDisponibility}
          pageSize={6}
          rowsPerPageOptions={[6]}
        />
      </Box>
      <div className="section-button">
        <CSVLink data={rowsDisponibility} target="_blank" >
          <Button variant="contained" color="success" style={{margin:'10px', width:'90px'}} >
            Excel
          </Button>
        </CSVLink>
        <Button variant="contained" color="success" style={{margin:'10px', width:'90px'}} onClick={exportToPDF}>
          PDF
        </Button>
      </div>
    </WrapperGrid>
  );
}
 
export default TableDisponibility;